import { Descriptions, List } from 'antd';

import { WebhookInterface } from '@interface/webhook/webhook.interface';

import { Wrapper } from './webhook-info.style';

export const WebhookInfo = (webhook: WebhookInterface) => (
  <Wrapper>
    <Descriptions size='small' title={webhook.deliveryUrl} bordered>
      <Descriptions.Item label='Unified Api' labelStyle={{ width: 160 }} span={1}>
        {webhook.unifiedApi}
      </Descriptions.Item>
      <Descriptions.Item label='Status' labelStyle={{ width: 120 }} span={2}>
        {webhook.status}
      </Descriptions.Item>
      <Descriptions.Item label='Delivery Url' labelStyle={{ width: 160 }} span={3}>
        {webhook.deliveryUrl}
      </Descriptions.Item>
      <Descriptions.Item label='Events' labelStyle={{ width: 160 }} span={3}>
        <List dataSource={webhook.events} renderItem={(item) => <List.Item>{item}</List.Item>} size='small' />
      </Descriptions.Item>
      <Descriptions.Item label='Description' labelStyle={{ width: 160 }} span={3}>
        {webhook.description}
      </Descriptions.Item>
    </Descriptions>
  </Wrapper>
);
